var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrello(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trello"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.2754 3.14466L3.77539 3.14626C2.94696 3.14638 2.27549 3.81806 2.27562 4.64648L2.27722 15.1465C2.27735 15.9749 2.94902 16.6464 3.77745 16.6463L14.2774 16.6447C15.1059 16.6445 15.7773 15.9729 15.7772 15.1444L15.7756 4.64443C15.7755 3.816 15.1038 3.14453 14.2754 3.14466Z",
    stroke: "#4C4C4C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.52539 6.14517L5.27539 6.14551L5.27642 12.8955L7.52642 12.8952L7.52539 6.14517Z",
    stroke: "#4C4C4C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.7754 6.14419L10.5254 6.14453L10.526 9.89453L12.776 9.89419L12.7754 6.14419Z",
    stroke: "#4C4C4C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrello);
export default __webpack_public_path__ + "static/media/trello.0d8082f3e8b4c4de28977b95d05a26d8.svg";
export { ForwardRef as ReactComponent };